import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { TagColumns } from "../../../tableColumns/table-columns";
import { TagJson } from "../../../DynamicFormsJson/MastersJSON/tag";
import { getTag } from "../../../Slice/tag.slice";
import {
  deleteFailedMsg,
  deletemsg,
  deleteWarningMsg,
  serverMsg,
} from "../../../config/messageconstant";
import { apiDelete } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import endpoint from "../../../config/endpoints";
class TagTable extends React.Component {
  constructor(props) {
    super(props);
  }
  rowDelete = (rowData) => {
    const { showNotification, showLoador } = this.props;

    if (rowData.id) {
      showLoador({ loador: true });
      apiDelete({
        url: endpoint.tag + "/" + rowData.id,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data && data.data.statusCode == 200) {
            showNotification({ msg: deletemsg });
            window.location.reload();
          } else {
            showNotification({ msg: deleteFailedMsg, severity: "error" });
          }
        } else {
          showNotification({
            msg: serverMsg,
            severity: "error",
          });
        }
      });
    }
  };
  render() {
    const { tagList, getTag } = this.props;
    return (
      <>
        <DynamicMainScreen
          formPath={TagJson.formPath}
          screenTitle={TagJson.screenTitle}
          fieldMeta={TagJson.fieldMeta}
          showPdfDownload={false}
          showExcelDownload={true}
          changeExcelURL={TagJson.excelUrl}
          showExtension={false}
          pdfFileName={TagJson.pdfFileName}
          excelFileName={TagJson.excelFileName}
          showAddButton={TagJson.showAddButton}
          tableColumnsToFilter={TagJson.tableColumnsToFilter}
          tableColumns={TagColumns}
          tableData={tagList?.tag}
          getTableData={getTag}
          apiBaseURL={TagJson.apiBaseURL}
          baseIdColumn={TagJson.baseIdColumn}
          isNote={true}
          isNoteValue={"Tag"}
          showDeleteIcon={true}
          isLog={true}
          type={0}
          deleteURLStatic={true}
          onDeleteStatic={this.rowDelete}
          showViewButtonInTable={true}
          formPathView={TagJson.formPathView}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  tagList: state.tag,
});
const mapDispatchToProps = {
  getTag,
  showNotification,
  showLoador,
};
export default connect(mapStateToProps, mapDispatchToProps)(TagTable);
